import React from "react";

// Makes a clickable non-button element (role="button"/"link") keyboard-operable: Enter or Space
// fires the same handler as a click. Spread onto the element alongside role + tabIndex={0}.
// e.g. <div role="button" tabIndex={0} onClick={open} onKeyDown={activateOnKey(open)} />
export function activateOnKey(handler: () => void): (event: React.KeyboardEvent) => void {
  return (event: React.KeyboardEvent): void => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handler();
    }
  };
}
